<template>
    <v-app id="app">
        <top-bar></top-bar>
        <v-content>
            <v-container pa-0 fluid>
                <transition name="fade">
                    <router-view></router-view>
                </transition>
                <v-snackbar :timeout="0" :class="{'mb-4':!$vuetify.breakpoint.xsOnly, 'ml-2':!$vuetify.breakpoint.xsOnly}" vertical :left="!$vuetify.breakpoint.xsOnly" :bottom="!$vuetify.breakpoint.xsOnly" v-model="cookieSnackbar">
                    <div>
                        <span style="font-size:large">We use Cookies!</span>
                        <br> To learn more about why we use cookies, check out our
                        <router-link style="display:inline-block" to="/privacy">privacy policy.</router-link>
                        <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
                        <v-btn :small="$vuetify.breakpoint.xsOnly" flat @click.stop="closeCookie" color="orange">accept</v-btn>
                    </div>
                </v-snackbar>
            </v-container>
        </v-content>
        <v-footer absolute app>
            <router-link to="/privacy"> Privacy Policy</router-link>
        </v-footer>
    </v-app>
</template>

<script>
import topBar from './components/top-bar/top-bar.vue';
export default {
    name: 'app',
    data() {
        return { cookieSnackbar: false };
    },
    components: {
        topBar
    },
    methods: {
        closeCookie() {
            this.cookieSnackbar = false;
            localStorage.seenCookieMessage = true;
        }
    },
    mounted() {
        if (
            !localStorage.seenCookieMessage &&
            window.location.hostname == 'subsearovers.com'
        ) {
            this.cookieSnackbar = true;
        }
    }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue